import PropTypes from "prop-types";

function ItemVideoSection({ videoUrl }) {
  if (!videoUrl) {
    return <p>No video found</p>;
  }

  let videoId;

  if (videoUrl.includes("youtu.be")) {
    const startIndex = videoUrl.indexOf(".be/") + 4;
    videoId = videoUrl.slice(startIndex);
  } else {
    let endIndex = videoUrl.length;
    if (videoUrl.includes("&")) endIndex = videoUrl.indexOf("&");
    videoId = videoUrl.slice(videoUrl.indexOf("=") + 1, endIndex);
  }

  return (
    <div className="w-full max-w-[50.625rem]">
      <iframe
        allowFullScreen
        title="Robodoc video"
        src={`https://www.youtube.com/embed/${videoId}`}
        className="aspect-[2/1] w-full rounded-[0.5rem] md:rounded-[0.875rem]"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      />
    </div>
  );
}

ItemVideoSection.propTypes = {
  videoUrl: PropTypes.string,
};

export default ItemVideoSection;
